import React from 'react';
import styles from './css/index.module.css';
import { Input } from '@fluentui/react-components';
import { Delete20Regular } from '@fluentui/react-icons';
import { PatchProjectData } from '../../redux/projectDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { toast } from 'react-toastify';

const AddCompetitors = () => {
    const dispatch = useDispatch();
    const { projectDetailButtonLoading, selectedProject } = useSelector(state => state.projectData);
    const [formData, setFormData] = React.useState(['']);

    const handleChange = (e, index) => {
        let data = [...formData];
        data[index] = e.target.value;
        // Allow empty string in any field, but ensure at least one field always exists
        setFormData(data);
    };

    const handleDelete = index => {
        // If it's the last field, clear the content instead of removing the field
        if (formData.length <= 1) {
            const newData = [...formData];
            newData[index] = '';
            setFormData(newData);
            return;
        }
        const newData = formData.filter((_, idx) => idx !== index);
        setFormData(newData);
    };

    const handleSubmit = async () => {
        // Filter out empty values before submitting
        const dataToSubmit = formData.filter(item => item !== '');

        // Validate URL length for non-empty URLs
        const maxUrlLength = 2000; // Reasonable limit for URLs
        const invalidUrls = dataToSubmit.filter(url => url.length > maxUrlLength);

        if (invalidUrls.length > 0) {
            toast.error(`URLs must be shorter than ${maxUrlLength} characters. Please shorten the following URLs: ${invalidUrls.join(', ')}`);
            return;
        }

        await dispatch(
            PatchProjectData({
                data: {
                    competitors: dataToSubmit,
                },
                id: selectedProject?.id,
            }),
        );
    };

    const handleSetFormValues = React.useCallback(() => {
        // Always ensure there's at least one field
        const competitors = selectedProject?.competitors || [];
        setFormData(competitors.length ? competitors : ['']);
    }, [selectedProject?.competitors]);

    const compareObjectsValues = (arr1 = [], arr2 = []) => {
        // Filter out empty values for comparison
        const cleanArr1 = (arr1 || []).filter(item => item !== '');
        const cleanArr2 = arr2.filter(item => item !== '');

        if (cleanArr1.length !== cleanArr2.length) {
            return false;
        }
        for (let i = 0; i < cleanArr1.length; i++) {
            if (cleanArr1[i] !== cleanArr2[i]) {
                return false;
            }
        }
        return true;
    };

    React.useEffect(() => {
        if (selectedProject) {
            handleSetFormValues();
        }
    }, [selectedProject, handleSetFormValues]);

    const hasChanges = !compareObjectsValues(selectedProject?.competitors, formData);

    return (
        <div className={styles.componentCard}>
            <h5 className={styles.componentTitle}>Competitors</h5>
            <div className="mb-4">
                {formData.length > 0
                    ? formData.map((item, index) => (
                          <div className="mb-2" key={index}>
                              <p className={styles.fieldLabel}>Competitor website</p>
                              <div className="d-flex align-items-center">
                                  <Input placeholder="Type here" className={styles.inputField + ' mb-2'} value={item} onChange={e => handleChange(e, index)} />
                                  <button
                                      type="button"
                                      onClick={() => handleDelete(index)}
                                      className={styles.deleteButton}
                                      title={formData.length > 1 ? 'Remove competitor' : 'Clear field'}
                                      disabled={formData.length === 1 && formData[index] === ''}>
                                      <Delete20Regular color={formData.length === 1 && formData[index] === '' ? '#6c757d' : 'var(--Brand-Secondary)'} />
                                  </button>
                              </div>
                          </div>
                      ))
                    : null}
                <p onClick={() => setFormData([...formData, ''])} className={styles.linkBtn}>
                    Add another
                </p>
            </div>
            <div className={styles.buttonDiv}>
                {hasChanges && (
                    <div className="d-flex align-items-center justify-content-between">
                        <button onClick={handleSubmit} className={styles.submitButton}>
                            Save {projectDetailButtonLoading && <AiOutlineLoading3Quarters className="ms-2 rotateLoader" />}
                        </button>
                        <span onClick={handleSetFormValues} className={styles.linkBtn}>
                            Revert
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddCompetitors;
